import { Link, useParams } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import MovieCard from '@/components/feature/MovieCard';
import DetailHero from '@/pages/detail/components/DetailHero';
import EpisodePanel from '@/pages/detail/components/EpisodePanel';
import { getMovieById, getRelatedMovies } from '@/utils/media';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Detail() {
  const { id = '' } = useParams();
  const movie = getMovieById(id);

  usePageMeta(
    movie ? `影视详情：${movie.title} - 红桃影视` : '影视详情 - 红桃影视',
    movie
      ? `${movie.title}（${movie.year}）由${movie.director}执导，${movie.actors.join('、')}主演，类型：${movie.genres.join('、')}。${movie.summary.slice(0, 60)}…`
      : '查看影视作品的详细信息、剧集列表与相关推荐。',
  );

  if (!movie) {
    return (
      <div className="px-4 md:px-6 lg:px-10 py-24 flex flex-col items-center text-center">
        <span className="w-20 h-20 rounded-full bg-background-200 flex items-center justify-center text-4xl text-foreground-500">
          <i className="ri-file-warning-line" />
        </span>
        <h1 className="mt-6 text-2xl font-bold text-foreground-950">影视资源不存在或已下架</h1>
        <p className="mt-3 text-foreground-600">你访问的资源可能已被移除，看看这些热门内容吧。</p>
        <Link
          to="/category/movie"
          className="inline-flex mt-6 px-6 h-11 items-center rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          去逛电影专区
        </Link>
      </div>
    );
  }

  const related = getRelatedMovies(movie, 6);

  return (
    <div className="pb-6">
      <div className="border-b border-background-300/60 bg-background-100">
        <div className="px-4 md:px-6 lg:px-10 py-5">
          <Breadcrumb
            items={[
              { label: movie.type === 'tv' ? '电视剧' : '电影', to: movie.type === 'tv' ? '/category/tv' : '/category/movie' },
              { label: movie.title },
            ]}
          />
        </div>
      </div>

      <div className="mt-8">
        <DetailHero movie={movie} />
      </div>

      <EpisodePanel movie={movie} />

      {related.length > 0 && (
        <section className="px-4 md:px-6 lg:px-10 mt-14">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading flex items-center gap-3 mb-6">
            <span className="w-1.5 h-7 rounded-full bg-primary-500" />
            相关推荐
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {related.map((item) => (
              <MovieCard key={item.id} movie={item} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}